import { motion } from "framer-motion";
import { FaSoap, FaStore, FaCar } from "react-icons/fa"; // iconos de detergente, tienda y auto

const NuestrosServicios = () => {
  const services = [
    {
      name: "Productos de alta calidad para mayor cuidado de tu ropa",
      icon: <FaSoap className="text-cyan-600 text-5xl" />, // botella/detergente
    },
    {
      name: "Comodidad de nuestras instalaciones",
      icon: <FaStore className="text-cyan-600 text-5xl" />, // tienda
    },
    {
      name: "Servicio Express y Autoservicio",
      icon: <FaCar className="text-cyan-600 text-5xl" />, // auto
    },
  ];

  return (
    <div className="h-fit relative py-20 bg-cyan-500">
      {/* Grid de servicios */}
      <div className="absolute top-0 left-0 w-full h-16 bg-white clip-path-diagonal-top"></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-6 md:px-12">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="flex flex-col items-center"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
            viewport={{ once: true }}
          >
            {/* Icono redondeado */}
            <div className="w-28 h-28 flex items-center justify-center bg-white rounded-full shadow-md">
              {service.icon}
            </div>

            {/* Texto */}
            <div className="p-4 flex flex-col flex-grow">
              <h3 className="text-white text-center font-semibold text-lg mb-2">
                {service.name}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="absolute bottom-0 left-0 w-full h-16 bg-white clip-path-diagonal-bottom"></div>
    </div>
  );
};

export default NuestrosServicios;
